import MockbeeDocumentation from "../../components/features/mockbee-documentation/MockbeeDocumentation";

const MockbeeDocumentationPage = () => {
  return <MockbeeDocumentation />;
};

export default MockbeeDocumentationPage;
